module.exports = __webpack_public_path__ + "media/images/about/ac_4-9b5c978e30320fcbb991b510c420e7e4.jpg";